module.exports = __webpack_public_path__ + "static/media/long-break-sound.9724d824.mp3";